export function normalizeCssUnits(value: string | number) {
  return typeof value === "number" ? `${value}px` : value;
}

export function removeStyleFromHtml(html: string) {
  return html.replace(/\s?style=(\\?['"])(?:(?!\1).)*(\1)/gi, "");
}
